module.exports = __webpack_public_path__ + "static/media/ball_2_5.e06dd201.mp3";